// extracted by mini-css-extract-plugin
export default {"productDescription":"g_-z","featuredDescription":"h_-z","description":"i_-z","more":"j_-z","descriptionSku":"k_-z"};